<template>
  <div class="header"></div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    
  }
}
</script>


